import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  fr: {
    translation: {
      // Navigation
      "nav.dashboard": "Tableau de bord",
      "nav.clients": "Clients",
      "nav.agents": "Agents",
      "nav.assignments": "Affectations",
      "nav.reports": "Rapports",
      "nav.logistics": "Logistique",
      "nav.admin": "Administration",
      
      // Dashboard
      "dashboard.title": "Tableau de bord",
      "dashboard.totalClients": "Total Clients",
      "dashboard.totalAgents": "Total Agents",
      "dashboard.activeAssignments": "Affectations Actives",
      "dashboard.totalReports": "Rapports Soumis",
      "dashboard.availableAgents": "Agents Disponibles",
      
      // Clients
      "clients.title": "Gestion des Clients",
      "clients.add": "Ajouter un Client",
      "clients.name": "Nom",
      "clients.email": "Email",
      "clients.phone": "Téléphone",
      "clients.address": "Adresse",
      "clients.contract": "Contrat N°",
      "clients.sites": "Sites Protégés",
      
      // Agents
      "agents.title": "Gestion des Agents",
      "agents.add": "Ajouter un Agent",
      "agents.name": "Nom",
      "agents.email": "Email",
      "agents.phone": "Téléphone",
      "agents.skills": "Compétences",
      "agents.availability": "Disponibilité",
      "agents.available": "Disponible",
      "agents.assigned": "Affecté",
      "agents.unavailable": "Indisponible",
      
      // Assignments
      "assignments.title": "Affectations",
      "assignments.add": "Nouvelle Affectation",
      "assignments.agent": "Agent",
      "assignments.client": "Client",
      "assignments.site": "Site",
      "assignments.shift": "Poste",
      "assignments.startDate": "Date de début",
      "assignments.status": "Statut",
      
      // Reports
      "reports.title": "Rapports d'Inspection",
      "reports.add": "Nouveau Rapport",
      "reports.client": "Client",
      "reports.site": "Site",
      "reports.visitDate": "Date de visite",
      "reports.observations": "Observations",
      "reports.recommendations": "Recommandations",
      "reports.photos": "Photos",
      
      // Logistics
      "logistics.title": "Gestion Logistique",
      "logistics.add": "Ajouter Article",
      "logistics.inventory": "Inventaire",
      "logistics.uniforms": "Uniformes",
      "logistics.equipment": "Équipements",
      "logistics.name": "Nom",
      "logistics.category": "Catégorie",
      "logistics.type": "Type",
      "logistics.quantity": "Quantité",
      "logistics.assignedTo": "Attribué à",
      "logistics.condition": "État",
      
      // Common
      "common.save": "Enregistrer",
      "common.cancel": "Annuler",
      "common.edit": "Modifier",
      "common.delete": "Supprimer",
      "common.search": "Rechercher",
      "common.actions": "Actions",
      "common.loading": "Chargement...",
      "common.logout": "Déconnexion",
      
      // Auth
      "auth.login": "Connexion",
      "auth.loginWithGoogle": "Se connecter avec Google",
      "auth.welcome": "Bienvenue",
    }
  },
  en: {
    translation: {
      "nav.dashboard": "Dashboard",
      "nav.clients": "Clients",
      "nav.agents": "Agents",
      "nav.assignments": "Assignments",
      "nav.reports": "Reports",
      "nav.logistics": "Logistics",
      "nav.admin": "Administration",
      
      "dashboard.title": "Dashboard",
      "dashboard.totalClients": "Total Clients",
      "dashboard.totalAgents": "Total Agents",
      "dashboard.activeAssignments": "Active Assignments",
      "dashboard.totalReports": "Submitted Reports",
      "dashboard.availableAgents": "Available Agents",
      
      "clients.title": "Client Management",
      "clients.add": "Add Client",
      "clients.name": "Name",
      "clients.email": "Email",
      "clients.phone": "Phone",
      "clients.address": "Address",
      "clients.contract": "Contract No.",
      "clients.sites": "Protected Sites",
      
      "agents.title": "Agent Management",
      "agents.add": "Add Agent",
      "agents.name": "Name",
      "agents.email": "Email",
      "agents.phone": "Phone",
      "agents.skills": "Skills",
      "agents.availability": "Availability",
      "agents.available": "Available",
      "agents.assigned": "Assigned",
      "agents.unavailable": "Unavailable",
      
      "assignments.title": "Assignments",
      "assignments.add": "New Assignment",
      "assignments.agent": "Agent",
      "assignments.client": "Client",
      "assignments.site": "Site",
      "assignments.shift": "Shift",
      "assignments.startDate": "Start Date",
      "assignments.status": "Status",
      
      "reports.title": "Inspection Reports",
      "reports.add": "New Report",
      "reports.client": "Client",
      "reports.site": "Site",
      "reports.visitDate": "Visit Date",
      "reports.observations": "Observations",
      "reports.recommendations": "Recommendations",
      "reports.photos": "Photos",
      
      "logistics.title": "Logistics Management",
      "logistics.add": "Add Item",
      "logistics.inventory": "Inventory",
      "logistics.uniforms": "Uniforms",
      "logistics.equipment": "Equipment",
      "logistics.name": "Name",
      "logistics.category": "Category",
      "logistics.type": "Type",
      "logistics.quantity": "Quantity",
      "logistics.assignedTo": "Assigned To",
      "logistics.condition": "Condition",
      
      "common.save": "Save",
      "common.cancel": "Cancel",
      "common.edit": "Edit",
      "common.delete": "Delete",
      "common.search": "Search",
      "common.actions": "Actions",
      "common.loading": "Loading...",
      "common.logout": "Logout",
      
      "auth.login": "Login",
      "auth.loginWithGoogle": "Sign in with Google",
      "auth.welcome": "Welcome",
    }
  },
  zh: {
    translation: {
      "nav.dashboard": "仪表板",
      "nav.clients": "客户",
      "nav.agents": "代理",
      "nav.assignments": "分配",
      "nav.reports": "报告",
      "nav.logistics": "物流",
      "nav.admin": "管理",
      
      "dashboard.title": "仪表板",
      "dashboard.totalClients": "总客户数",
      "dashboard.totalAgents": "总代理数",
      "dashboard.activeAssignments": "活跃分配",
      "dashboard.totalReports": "已提交报告",
      "dashboard.availableAgents": "可用代理",
      
      "clients.title": "客户管理",
      "clients.add": "添加客户",
      "clients.name": "姓名",
      "clients.email": "电子邮件",
      "clients.phone": "电话",
      "clients.address": "地址",
      "clients.contract": "合同号",
      "clients.sites": "受保护站点",
      
      "agents.title": "代理管理",
      "agents.add": "添加代理",
      "agents.name": "姓名",
      "agents.email": "电子邮件",
      "agents.phone": "电话",
      "agents.skills": "技能",
      "agents.availability": "可用性",
      "agents.available": "可用",
      "agents.assigned": "已分配",
      "agents.unavailable": "不可用",
      
      "assignments.title": "分配",
      "assignments.add": "新分配",
      "assignments.agent": "代理",
      "assignments.client": "客户",
      "assignments.site": "站点",
      "assignments.shift": "班次",
      "assignments.startDate": "开始日期",
      "assignments.status": "状态",
      
      "reports.title": "检查报告",
      "reports.add": "新报告",
      "reports.client": "客户",
      "reports.site": "站点",
      "reports.visitDate": "访问日期",
      "reports.observations": "观察",
      "reports.recommendations": "建议",
      "reports.photos": "照片",
      
      "logistics.title": "物流管理",
      "logistics.add": "添加项目",
      "logistics.inventory": "库存",
      "logistics.uniforms": "制服",
      "logistics.equipment": "设备",
      "logistics.name": "名称",
      "logistics.category": "类别",
      "logistics.type": "类型",
      "logistics.quantity": "数量",
      "logistics.assignedTo": "分配给",
      "logistics.condition": "状况",
      
      "common.save": "保存",
      "common.cancel": "取消",
      "common.edit": "编辑",
      "common.delete": "删除",
      "common.search": "搜索",
      "common.actions": "操作",
      "common.loading": "加载中...",
      "common.logout": "登出",
      
      "auth.login": "登录",
      "auth.loginWithGoogle": "使用 Google 登录",
      "auth.welcome": "欢迎",
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'fr',
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
